import type { LandingPageData } from "../../types/landing-page-data";
import JsonData from "../../services/data.json";
import { About } from "./components/about";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { Platform } from "./components/platform";
import { Services } from "./components/services";
import { Contact } from "./components/contact";
import { HowItWorks } from "./components/how-it-works";
import { Gallery } from "./components/gallery";

const SHOW_PRODUCT_GALLERY = false;

export const HomePage = () => {
  const landingPageData = JsonData as LandingPageData;

  return (
    <div id="page-top" className="bg-white text-slate-900">
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <HowItWorks />
      {SHOW_PRODUCT_GALLERY && <Gallery data={landingPageData.Gallery} />}
      <Platform data={landingPageData.Platform} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      {/* Preços permanecem indisponíveis na página pública. */}
      {/* <Pricing data={landingPageData.Pricing} /> */}
      <Contact data={landingPageData.Contact} />
    </div>
  );
};
